module.exports = __webpack_public_path__ + "static/media/Portrait-10066_original.d8a5ce84.jpg";